<div class="inner-page-wrapper flex flex-col gap-24 md:grid md:grid-cols-2 lg:grid-cols-3">
    @for (vehicle of vehicles(); track vehicle.id) {
        <lib-vehicle-card [vehicle]="vehicle" />
    }
</div>
